import { Route, Routes } from 'react-router';
import type { MultiLang } from '../config';
import Announce from '../custom/blocks/Announce';
import Rankings from '../database/blocks/Rankings';
import RecentContents from '../database/blocks/RecentContents';
import DatabaseTop from '../database/DatabaseTop';
import Functions from '../functions';
import MainContent from './MainContent';

interface Props {
    lang: MultiLang;
}

const CenterBlocks = (props: Props) => {
    const { lang } = props;
    return (
        <div className="block">
            <div className="centerCcolumn">
                <div className="block">
                    <h2 className="blockTitle">{Functions.mlang('[en]Announce[/en][ja]ご案内[/ja]', lang)}</h2>
                    <div className="blockContent">
                        <Announce lang={lang} />
                    </div>
                </div>
                <div className="block">
                    <h2 className="blockTitle">
                        {Functions.mlang('[en]Item Types[/en][ja]アイテムタイプ一覧[/ja]', lang)}
                    </h2>
                    <div className="blockContent">
                        <DatabaseTop lang={lang} />
                    </div>
                </div>
            </div>
            <div className="clearfix">
                <div className="centerLcolumn">
                    <div className="block">
                        <h2 className="blockTitle">{Functions.mlang('[en]Ranking[/en][ja]ランキング[/ja]', lang)}</h2>
                        <div className="blockContent">
                            <Rankings lang={lang} />
                        </div>
                    </div>
                </div>
                <div className="centerRcolumn">
                    <div className="block">
                        <h2 className="blockTitle">
                            {Functions.mlang('[en]Recent Contents[/en][ja]新着コンテンツ[/ja]', lang)}
                        </h2>
                        <div className="blockContent">
                            <RecentContents lang={lang} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const CenterColumn = (props: Props) => {
    const { lang } = props;
    return (
        <div className="centercolumn">
            <Routes>
                <Route path="/" element={<CenterBlocks lang={lang} />} />
                <Route path="*" element={null} />
            </Routes>
            <div className="block">
                <MainContent lang={lang} />
            </div>
        </div>
    );
};

export default CenterColumn;
